import CheckoutError from './CheckoutError.js'

export default class OrderCheckoutError extends CheckoutError {}
